import { useEffect, useState } from 'react';
import Location from '../../hooks/Location';
import { useFirestoreID, useFirestoreGeneralTwo } from '../../firebase/useFirestore';
import ResearchResultsPageHeader from '../../components/measurementPlan/ResearchResultsPageHeader.jsx';
import ResearchResultsQuestionList from '../../components/measurementPlan/ResearchResultsQuestionList.jsx';

/**
 * Eén ingevulde sessie: zelfde weergave als het formulier, maar de antwoorden
 * horen bij een `SessionID` in plaats van bij een `FormID`.
 */
const ResearchResultsSessions = () => {
    // State
    const [researchTitle, setResearchTitle] = useState('');
    const [questionnaireId, setQuestionnaireId] = useState('');

    // Hooks
    const researchId = Location()[3];
    const sessionId = Location()[4];
    const match = [['SessionID', sessionId || '']];

    // Firestore
    const research = useFirestoreID('Research', researchId ? researchId : '');
    // Alle antwoorden van deze sessie — voedt datum, meetmoment en telling in de kop.
    const sessionResponses = useFirestoreGeneralTwo(
        'QuestionnairesResponses', 'SessionID', sessionId || '', 'ResearchID', researchId || ''
    );

    // Zet de onderzoekstitel + de vragenlijst (werkt voor een reeks of één doc).
    useEffect(() => {
        if (!research) return;
        const item = Array.isArray(research) ? research[0] : research;
        if (item) {
            setResearchTitle(item.Title ?? '');
            setQuestionnaireId(item.QuestionnaireID ?? '');
        }
    }, [research]);

    return (
        <div className="main">
            <div className="main-container">
                <ResearchResultsPageHeader heading={researchTitle} responses={sessionResponses} />
                <ResearchResultsQuestionList
                    questionnaireId={questionnaireId}
                    researchId={researchId}
                    match={match}
                />
            </div>
        </div>
    );
};

export default ResearchResultsSessions;
